import React, { useEffect } from "react";

const Expertise = () => {
  useEffect(() => {
    const gauges = document.querySelectorAll(".gauge");

    gauges.forEach((gauge) => {
      const percentage = gauge.getAttribute("data-percentage");
      const count = gauge.getAttribute("data-count");
      const circle = gauge.querySelector(".progress");
      const number = gauge.querySelector(".number");

      // Circle circumference
      const radius = circle.r.baseVal.value;
      const circumference = 2 * Math.PI * radius;

      circle.style.strokeDasharray = circumference;
      circle.style.strokeDashoffset = circumference;

      // Animate progress
      setTimeout(() => {
        const offset = circumference - (percentage / 100) * circumference;
        circle.style.strokeDashoffset = offset;
      }, 300);

      // Animate numbers
      let start = 0;
      const end = parseInt(count.replace(/\D/g, ""));
      const duration = 2000;
      const stepTime = Math.abs(Math.floor(duration / end));

      const timer = setInterval(() => {
        start++;
        number.textContent = `+${start}k`;
        if (start === end) {
          clearInterval(timer);
        }
      }, stepTime);
    });
  }, []);

  return (
    <section className="Expertise">
      <div className="gauge" data-percentage="75" data-count="+2k">
        <svg viewBox="0 0 120 120">
          <circle className="bg" cx="60" cy="60" r="52"></circle>
          <circle className="progress" cx="60" cy="60" r="52"></circle>
        </svg>
        <div className="gauge-text">
          <div className="number">+0k</div>
          <div className="label">Expertise</div>
        </div>
      </div>

      <div className="gauge" data-percentage="55" data-count="+11k">
        <svg viewBox="0 0 120 120">
          <circle className="bg" cx="60" cy="60" r="52"></circle>
          <circle className="progress" cx="60" cy="60" r="52"></circle>
        </svg>
        <div className="gauge-text">
          <div className="number">+0k</div>
          <div className="label">Clients</div>
        </div>
      </div>

      <div className="gauge" data-percentage="45" data-count="+5k">
        <svg viewBox="0 0 120 120">
          <circle className="bg" cx="60" cy="60" r="52"></circle>
          <circle className="progress" cx="60" cy="60" r="52"></circle>
        </svg>
        <div className="gauge-text">
          <div className="number">+0k</div>
          <div className="label">Recruiters</div>
        </div>
      </div>

      <div className="gauge" data-percentage="85" data-count="+20k">
        <svg viewBox="0 0 120 120">
          <circle className="bg" cx="60" cy="60" r="52"></circle>
          <circle className="progress" cx="60" cy="60" r="52"></circle>
        </svg>
        <div className="gauge-text">
          <div className="number">+0k</div>
          <div className="label">Placements</div>
        </div>
      </div>
    </section>
  );
};

export default Expertise;
